export default __webpack_public_path__ + "static/media/ava-04.eae79284.png";